/** Server-owned Floating Ani chips may include this token; the client substitutes from live OS context. */
export const SAMPLE_PROMPT_HOUSEHOLD_PLACEHOLDER = "{{household}}";

const PLACEHOLDER_PATTERN = /\{\{household\}\}/g;

export function samplePromptHasHouseholdPlaceholder(template: string): boolean {
  return template.includes(SAMPLE_PROMPT_HOUSEHOLD_PLACEHOLDER);
}

/** Drop chips that still need a household name when none is resolved; substitute otherwise. */
export function personalizeSamplePromptTemplates(
  templates: string[],
  householdName: string | null | undefined,
): string[] {
  const household = householdName?.trim() ?? "";
  const out: string[] = [];
  for (const template of templates) {
    const text = template.trim();
    if (!text) continue;
    if (samplePromptHasHouseholdPlaceholder(text) && !household) {
      continue;
    }
    out.push(household ? text.replace(PLACEHOLDER_PATTERN, household) : text);
  }
  return out;
}
